import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface RightSidebar {
  isOpenRightSidebar: boolean;
  isGetInitialData: boolean;
  isShowInputLoader: boolean;
  rightSidebarSelectedTab: string;
}

const initialState: RightSidebar = {
  isOpenRightSidebar: false,
  isGetInitialData: false,
  isShowInputLoader: false,
  rightSidebarSelectedTab: '',
};

export const rightSidebarSlice = createSlice({
  name: 'rightSidebarSlice',
  initialState,
  reducers: {
    toggleOpenRightSidebar: (state, action: PayloadAction<boolean>) => {
      state.isOpenRightSidebar = action.payload;
    },

    setRightSidebarSelectedTab: (state, action: PayloadAction<string>) => {
      state.rightSidebarSelectedTab = action.payload;
    },
  },
});

export const { toggleOpenRightSidebar, setRightSidebarSelectedTab } = rightSidebarSlice.actions;
export default rightSidebarSlice.reducer;
